import React from 'react';

interface ErrorFieldProps {
  error: string;
}

const ErrorField: React.FC<ErrorFieldProps> = ({ error }) => (
  <p className="mt-1 text-xs text-red-600 dark:text-red-500">{error}</p>
);

export default ErrorField;
